module.exports = __webpack_public_path__ + "be0f03f7e452cd255c249aafe6fdc21b.png";